const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null
};

const reducer = (state = INIT_STATE, action)=>{
	switch (action.type) {
		case 'GET_SHIPPINGS':
			return { ...state, loading: true, error: false, errorMessage: null, action: null, list: [] };

		case 'GET_SHIPPINGS_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_SHIPPINGS_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_SHIPPING':
			return { ...state, loading: true, error: false, action: null };

		case 'GET_SHIPPING_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_SHIPPING_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_SHIPPING':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_SHIPPING_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED' }

		case 'CREATE_SHIPPING_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_SHIPPING':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_SHIPPING_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'UPDATE_SHIPPING_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_SHIPPING':
			return { ...state, loading: true, action: null }

		case 'DELETE_SHIPPING_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_SHIPPING_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;
	}
};

export default reducer;